import '@/styles/main.scss'
import 'v-calendar/style.css'
import 'tippy.js/dist/tippy.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VCalendar from 'v-calendar'

import App from '@/App.vue'
import router from '@/router'
import { useAppStore } from '@/stores/app'
import { setupI18n } from '@/i18n'

const pinia = createPinia()

useAppStore(pinia)
  .boot()
  .then(() => {
    const app = createApp(App)
    const i18n = setupI18n()
    app.use(pinia)
    app.use(i18n)
    app.use(router)
    app.use(VCalendar, {})
    app.mount('#app')
  })
